import httpClient from './httpClient';

export const fetchUsers = () => httpClient.get('/admin/users', { auth: true });

export const createUser = (values) => httpClient.post('/admin/users', values, { auth: true });

export const updateUser = (id, values) => httpClient.put(`/admin/users/${id}`, values, { auth: true });

export const deleteUser = (id) => httpClient.delete(`/admin/users/${id}`, { auth: true });

export const impersonateUser = (id) =>
    httpClient.post(`/admin/users/${id}/impersonate`, {}, { auth: true });

export const stopImpersonation = () =>
    httpClient.post('/admin/users/stop-impersonation', {}, { auth: true });

export const fetchSettings = () => httpClient.get('/admin/settings', { auth: true });

export const updateSettings = (values) => httpClient.put('/admin/settings', values, { auth: true });
